import { Component, OnInit } from '@angular/core';
import { MainNavigationService } from '../main-navigation.service';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { MainMenu } from '../main-menu-item.interface';
import { CartService } from '../cart.service'; // Import CartService

@Component({
  selector: 'tea-shop-fe-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.css'],
  standalone: false
})
export class TopNavigationComponent implements OnInit {
  mainMenu$!: Observable<MainMenu>;
  cartItemCount$!: Observable<number>; // Add cartItemCount$ property

  showDropdown: { [key: string]: boolean } = {};

  constructor(
    private mainNavigationService: MainNavigationService,
    private cartService: CartService // Inject CartService
  ) { }

  ngOnInit() {
    this.mainMenu$ = this.mainNavigationService.getMainMenu().pipe(share());
    this.cartItemCount$ = this.cartService.getCartItemCount(); // Initialize cartItemCount$
  }

  closeDropdowns(event: Event, exceptItem: string | null) {
    event.stopPropagation();
    Object.keys(this.showDropdown).forEach((key) => {
      if (key !== exceptItem /* && key !== 'mobileMenu' */) { // I think we want the mobile menu to close when we click on a link
        this.showDropdown[key] = false;
      }
    });
    window.scrollTo(0, 0); // TODO : Need to do this the angular way with a dependency injection
  }
}
